<template>
  <v-container :key="(subattending) ? subattending.id : null" v-if="!$store.state.loading && current_attending">
    <v-tabs
      v-model="tabs"
      fixed-tabs
    >
      <v-tab
        href="#attend"
      >
        Atender &nbsp; <span>({{ subattendings || 0 }})</span>
      </v-tab>
      <v-tab
        href="#attend-history"
        
      >
        Histórico de atendimento
        <v-icon>mdi-calendar</v-icon>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item value="attend">
        <v-row rows="12">
          <v-col xs="12" sm="6">
            <v-select
              v-model="storeUuid"
              :items="(($store.state.attending_stores).filter( x => x.pivot.active)).map(as =>  ({value: as.uuid, text: as.name}) )"
              @input="handleChangeStore"
              label="Atender produto"
            ></v-select>
          </v-col>
          <v-col xs="12" sm="6">
            <v-select
              v-model="status"
              @input="fetchSubAttending"
              :items="current_attending.contact_statuses.map(cs => ({value: cs.id, text: cs.status}))"
              label="Status do pedido"
            ></v-select>
          </v-col>
        </v-row>
        
        <AttendingCard 
          v-if="subattending" 
          :subattending="subattending"
          :status="status"
          :scheduleAction="true"
          v-on:updateCurrentAttending="fetchSubAttending"
          @openScheduleDialog="openScheduleDialog"
        />
        
        
        <div v-else>
          <v-alert
            dense
            type="info"
          >
            Não há transações com status 
            {{current_attending.contact_statuses.find(cs => cs.id === this.status).status}}
            para o produto {{current_attending.store.name}}
          </v-alert>
        </div>

      </v-tab-item>
      <v-tab-item value="attend-history">
        <AttendingHistory @openScheduleDialog="schedule => dialog = true"/>
      </v-tab-item>
    </v-tabs-items>
    
    <CreateSchedule            
      @closeDialog="closeDialog"  
      :dialog="dialog"
      :subattending="subattending"
    />

  </v-container>
</template>

<script>
  import AttendStatusTab from './AttendStatusTab';
  import AttendingCard from '../Attending/AttendingCard'
  import AttendingHistory from '../Attending/History';
  import CreateSchedule from '../Attending/schedule/Create';
  
  import request  from '../../request';
  
  export default {
    components: {
      AttendStatusTab,
      AttendingHistory,
      AttendingCard, 
      CreateSchedule  
    },
    name: 'Attend',
    created() {
      this.$store.dispatch('fetchAttendingStores');
      this.storeUuid = this.$route.params.uuid;
      this.fetchAttendingStore();    
    },
    methods: {
      fetchSubAttending() {
        this.$store.commit('setLoading', {data: true})
        request({
          method: 'get',
          url: `/api/attendings/subattending/${this.storeUuid}/${this.status}`,
          auth: true,
        })
        .then(response => {
          console.log('updated');

          this.subattending = response.data.subattending || null;
          this.subattendings = response.data.total || null;

          this.$store.commit('setLoading', {data: false})
        })
        .catch(err => {
          this.$store.commit('setLoading', {data: false})
        });
      },
      fetchAttendingStore() {
        this.$store.commit('setLoading', {data: true})
        request({
          method: 'get',
          url: `/api/userstore/store-uuid/${this.storeUuid}`,
          auth: true,
        })
        .then(response => {
          this.current_attending = response.data;
          this.status = response.data.contact_statuses[0].id;
          this.fetchSubAttending();
          this.$store.commit('setLoading', {data: false})
        })
        .catch(err => {
          this.$store.commit('setLoading', {data: false})
        });
      },
      setAttendingHistorySearch() {
        if (this.prevSearch) {
          clearTimeout(this.prevSearch);
        }
        this.prevSearch = setTimeout( () => this.$store.dispatch('setAttendingHistorySearch', this.filters.search)

        , 500);
      },
      handleChangeStore() {
        this.$router.push({path: `/store/attend/${this.storeUuid}`})
        this.fetchAttendingStore();
        this.fetchSubAttending();
      },
      closeDialog(update = false) {
        this.dialog = false;
        this.selected = null;

        if(update) {
          this.subattending = null;
          this.fetchSubAttending();
        }
      },
      openScheduleDialog(subattending)  {
        this.subattending = subattending
        this.dialog = true;
      }
    },
    
    data () {
      return {
        dialog: false,
        current_attending: null,
        status: null,
        subattending: null,
        subattendings: null,
        storeUuid: null,
        tabs: null,
        selected: null
      }
    }
  }
</script>

<style lang="css" scoped>
</style>